import i18n from "../../../../i18n"

export const requiredValidator = (value) => {
    if (!value || (typeof value === "string" && value.trim() === '')) return i18n.t('requiredField', { ns: 'common' })
    return ''
}
